export default function getEnumTypeKeys(type: any): string[] {
	return Object.keys(type).filter(e => Number.isNaN(Number(e)));
}
